invalidTakeMaybeHandler